import { useCallback } from "react";
import {
  Card,
  BlockStack,
  Text,
  TextField,
} from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { Brand } from "@features/events/types";

interface BillingEmailCardProps {
  brandData: Partial<Brand>;
  onDataChange: (updates: Partial<Brand>) => void;
  fieldErrors: Record<string, string>;
}

export default function BillingEmailCard({
  brandData,
  onDataChange,
  fieldErrors,
}: BillingEmailCardProps) {
  const { t } = useTranslation();

  const handleBillingEmailChange = useCallback(
    (value: string) => {
      onDataChange({ billingEmail: value });
    },
    [onDataChange]
  );

  return (
    <Card>
      <BlockStack gap="400">
        <Text variant="headingMd" as="h2">
          {t("brandProfile.billing.title")}
        </Text>
        <Text as="p" variant="bodyMd" tone="subdued">
          {t("brandProfile.billing.subtitle")}
        </Text>

        <TextField
          label={t("brandProfile.billing.email")}
          type="email"
          value={brandData.billingEmail || ""}
          onChange={handleBillingEmailChange}
          error={fieldErrors.billingEmail}
          helpText={t("brandProfile.billing.emailHelpText")}
          autoComplete="email"
          placeholder={t("common.placeholders.emailList")}
          requiredIndicator
        />
      </BlockStack>
    </Card>
  );
}

